import { useEffect } from "react";
import { ProjectList } from "@lifeat/shared/projects/ProjectsTypes";
import "@lifeat/shared/task-management/TaskFilterTypes";
import { userTaskDataCollection } from "@lifeat/shared/task-management/TaskManagementTypes";
import { FirestoreService } from "@service/FirestoreService";
import { allTasksWithProject$, projectList$ } from "./ProjectGlobals";

/**
 * @param uid User ID to fetch projects data for and perform operations on
 */
export default function useProjectsData(uid: string | undefined | null) {
    const fs = FirestoreService();

    const filterOutArchivedProjects = (projects: ProjectList) => {
        const filtersProjectsEntries = {};
        Object.entries(projects).filter(([projectId, project]) => {
            if (!project.isArchived) {
                filtersProjectsEntries[projectId] = project;
            }
        });

        return filtersProjectsEntries;
    };

    useEffect(() => {
        if (uid) {
            const unsub = fs.getCollectionListener(userTaskDataCollection.at(uid).at("projects").node, (payload) => {
                if (payload.success && payload.value != null) {
                    projectList$.value = filterOutArchivedProjects(payload.value);
                } else {
                    projectList$.value = {};
                }
            });
            return () => {
                unsub();
            };
        } else {
            return undefined;
        }
    }, [uid]);

    useEffect(() => {
        if (uid) {
            const tasksNode = userTaskDataCollection.at(uid).at("tasks").node;
            const unsub = fs.getCollectionListener(
                tasksNode,
                (payload) => {
                    if (payload.success && payload.value != null) {
                        allTasksWithProject$.value = payload.value;
                    }
                },
                {
                    // Only listen to tasks that have a projectId
                    filters: [
                        {
                            fieldPath: "projectId",
                            opStr: "!=",
                            value: null,
                        },
                    ],
                },
            );
            return () => {
                unsub();
            };
        }
        return undefined;
    }, [uid]);
}
